import { flatten, max } from "lodash"

export default class Lines extends Component {
  state = { allPathObjs: [] }

  /*
  componentDidReceiveProps() {
    this.showLines()
  }

  el = null
  */

  el = null

  showLines = el => {
    if (!this.el && !el) return

    if (el) {
      this.el = el
    }

    el = this.el
    const elRect = el.getBoundingClientRect()

    const { allPaths } = this.props

    const allPathObjs = allPaths.map(paths => {
      const nodes = Array.from(el.querySelectorAll("[data-line-id]"))
      const shapes = {}
      nodes.forEach(node => {
        const id = node.getAttribute("data-line-id")
        const {
          left,
          top,
          right,
          bottom,
          width,
          height,
        } = node.getBoundingClientRect()

        const bounding = {
          left: left - elRect.left,
          top: top - elRect.top,
          right: right - elRect.left,
          bottom: bottom - elRect.top,
          width,
          height,
        }

        shapes[id] = bounding
      })

      const pathObjs = flatten(
        nodes.map(node => {
          const id = node.getAttribute("data-line-id")
          const connectsTo = paths[id] || {}
          const shape = shapes[id]

          return Object.keys(connectsTo)
            .map(toId => {
              let weight = connectsTo[toId]
              const toShape = shapes[toId]
              if (!shape || !toShape) return null
              const useLeft = shape.left > toShape.left

              const anchor = {
                x: useLeft ? shape.left : shape.right,
                y: shape.top + shape.height / 2,
              }

              const toAnchor = {
                x: useLeft ? toShape.right : toShape.left,
                y: toShape.top + toShape.height / 2,
              }

              return {
                id,
                weight,
                toId,
                shape,
                anchor,
                toAnchor,
              }
            })
            .filter(i => i !== null)
        }),
      )

      return pathObjs
    })

    this.setState({ allPathObjs })
  }

  componentWillReceiveProps() {
    setTimeout(() => {
      this.showLines()
    }, 0)
  }

  render() {
    const { allPathObjs } = this.state
    const { children, showNode } = this.props
    const deltaX = 30

    const height = Math.max(
      1500,
      max(flatten(allPathObjs[0]).map(({ shape }) => shape.bottom)),
    )

    return (
      <Surface position="relative">
        <div ref={this.showLines}>{children}</div>
        <svg
          width={window.innerWidth - 100}
          height={height}
          style={{ position: "absolute", zIndex: 1000, pointerEvents: "none" }}
        >
          {allPathObjs.map((pathObjs, index) =>
            pathObjs.map(({ anchor, toAnchor, id, toId, weight }) => {
              const halfX = anchor.x + (toAnchor.x - anchor.x) / 2

              const hidden = showNode && id !== showNode && toId !== showNode

              return (
                <path
                  key={id + "-" + toId}
                  onMouseEnter={() => console.log("value is", weight)}
                  d={`M ${anchor.x},${anchor.y} C ${halfX},${
                    anchor.y
                  } ${halfX},${toAnchor.y} ${toAnchor.x},${
                    toAnchor.y
                  } ${toAnchor.x - deltaX},${toAnchor.y}
               L ${toAnchor.x},${toAnchor.y}`}
                  style={{
                    stroke: "black",
                    strokeWidth: weight * 20,
                    pointerEvents: "all",
                    opacity: hidden ? 0 : Math.pow(weight * 1.5, 1.5),
                    transition: "all 350ms ease-out",
                    fill: `none`,
                  }}
                />
              )
            }),
          )}
        </svg>
      </Surface>
    )
  }
}
